import { render, staticRenderFns } from "./Spare.view.vue?vue&type=template&id=df130912&"
import script from "./Spare.view.vue?vue&type=script&lang=js&"
export * from "./Spare.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports